export default __webpack_public_path__ + "static/media/game-sound-hard.e7d61045.mp3";